export const Cloth = [
  {
    title: "Tops",
    path: "/top",
  },
  {
    title: "Dresses",
    path: "/dresses",
  },
  {
    title: "Pants",
    path: "/pants",
  },
  {
    title: "Denim",
    path: "/denim",
  },
  {
    title: "Sweaters",
    path: "/sweaters",
  },
  {
    title: "T-Shirts",
    path: "/t-shirts",
  },
  {
    title: "Jackets",
    path: "/jackets",
  },
  {
    title: "Activewear",
    path: "/activewear",
  },
];

export const Categories = [
  {
    title: "Ephone",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat4.jpg",
  },
  {
    title: "Fashion",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat5.jpg",
  },
  {
    title: "Furniture",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat7.jpg",
  },
  {
    title: "Headphone",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat4.jpg",
  },
  {
    title: "Smartphone",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat3.jpg",
  },
  {
    title: "Towels could",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat2.jpg",
  },
  {
    title: "Watches",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat1.jpg",
  },
  {
    title: "Sweaters",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat6.jpg",
  },
  {
    title: "T-Shirts",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat2.jpg",
  },
  {
    title: "Jackets",
    img: "https://cdn-dgijh.nitrocdn.com/BIjtIohnXhjzStiBjRtrXSbTaWlmZHIX/assets/static/optimized/rev-9aa57ee/themes/sw_emarket/layout2/wp-content/uploads/2017/07/cat3.jpg",
  }
];

export const Accessories = [
  {
    title: "Watches",
    path: "/watches",
    description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. ",
    Img: "https://images.unsplash.com/photo-1620625515032-6ed0c1790c75?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fHdhdGNoZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    title: "Shoes",
    path: "/shoes",
    description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    Img: "https://media.istockphoto.com/photos/running-shoes-picture-id1249496770?b=1&k=20&m=1249496770&s=170667a&w=0&h=_SUv4odBqZIzcXvdK9rqhPBIenbyBspPFiQOSDRi-RI=",
  },
  {
    title: "Wallets",
    path: "/wallets",
    description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    Img: "https://images.unsplash.com/photo-1560472355-536de3962603?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTh8fHdhbGxldHN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    title: "Bags",
    path: "/bags",
    description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    Img: "https://images.unsplash.com/photo-1594223274512-ad4803739b7c?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8YmFnc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    title: "Sunglasses",
    path: "/sunglasses",
    description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    Img: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8c3VuZ2xhc3Nlc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    title: "Sweaters",
    path: "/sweaters",
    description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    Img: "https://images.unsplash.com/photo-1517677208171-0bc6725a3e60?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8c3dlYXRlcnN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
  },
  {
    title: "Hats",
    path: "/hats",
    description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    Img: "https://media.istockphoto.com/photos/working-peaked-cap-isolated-on-a-white-background-picture-id1181588872?b=1&k=20&m=1181588872&s=170667a&w=0&h=nWcu49k84oFNyYeoJYbyeLx_gQ-SdBSr_0RLOgrWAuc=",
  },
  {
    title: "Belts",
    path: "/belts",
    description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    Img: "https://media.istockphoto.com/photos/collection-of-leather-belts-on-a-wooden-table-picture-id1029383076?b=1&k=20&m=1029383076&s=170667a&w=0&h=PcgV3I80nYqZedJENjd6xJSnApE1kLAJ8APjidBBWWM=",
  },
];

export const Brands = [
  {
    title: "Full Nelson",
    path: "/full-nelson",
  },
  {
    title: "My Way",
    path: "/my-way",
  },
  {
    title: "Re-Arranged",
    path: "/re-Arranged",
  },
  {
    title: "Counterfeit",
    path: "/counterfeit",
  },
  {
    title: "Significant Other",
    path: "/significant-Other",
  },
  {
    title: "Best Buy",
    path: "/best-buy",
  },
  {
    title: "Belts Away",
    path: "/belts-away",
  },
];

export const CloseProducts = [
  {
    title: "Classic Utility Jacket",
    price: "110",
    SizeGuide: "Size Guide",
    xs: " XS",
    s: "S",
    m: "M",
    L: "L",
    xl: "XL",
    stock: "Out of Stock",
    BuyNow: "Buy now",
    AddToBag: "Add to bag",
    shipping: "Free shipping on all continental US orders.",
    img: "https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-01.jpg",
  },
  {
    title: "Classic Utility Jacket",
    price: "110",
    SizeGuide: "Size Guide",
    xs: " XS",
    s: "S",
    m: "M",
    L: "L",
    xl: "XL",
    stock: "In Stock",
    BuyNow: "Buy now",
    AddToBag: "Add to bag",
    shipping: "Free shipping on all continental US orders.",
    img: "https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-03.jpg",
  },
  {
    title: "Classic Utility Jacket",
    price: "110",
    SizeGuide: "Size Guide",
    xs: " XS",
    s: "S",
    m: "M",
    L: "L",
    xl: "XL",
    stock: "In Stock",
    BuyNow: "Buy now",
    AddToBag: "Add to bag",
    shipping: "Free shipping on all continental US orders.",
    img: "https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-02.jpg",
  },

  {
    title: "Classic Utility Jacket",
    price: "110",
    SizeGuide: "Size Guide",
    xs: " XS",
    s: "S",
    m: "M",
    L: "L",
    xl: "XL",
    stock: "In Stock",
    BuyNow: "Buy now",
    AddToBag: "Add to bag",
    shipping: "Free shipping on all continental US orders.",
    img: "https://tailwindui.com/img/ecommerce-images/home-page-03-hero-image-tile-07.jpg",
  },
];

export const NewArrivals = [
  {
    title: "New Arrivals",
    path: "/shop",
    womenImg:
      "https://tailwindui.com/img/ecommerce-images/mega-menu-category-01.jpg",
    menImg:
      "https://tailwindui.com/img/ecommerce-images/product-page-04-detail-product-shot-01.jpg",
    shopImg:
      "https://images.unsplash.com/photo-1622979138084-c03ae28968ed?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
  },
  {
    title: "Basic Tees",
    path: "/shop",
    womenImg:
      "https://tailwindui.com/img/ecommerce-images/mega-menu-category-02.jpg",
    menImg:
      "https://tailwindui.com/img/ecommerce-images/category-page-02-image-card-06.jpg",
    shopImg:
      "https://images.unsplash.com/photo-1515849430397-7aee921bbea1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80",
  },
];

export const Menu = [
  {
    title: "Home",
    path: "/",
    class:
      "py-2 px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
    toggleClass:
      "py-3  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  },
  {
    title: "Shop",
    path: "/shop",
    class:
      "py-2 flex items-center  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
    toggleClass:
      "py-3  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  },
  {
    title: "men",
    path: "/shop",
    class:
      "py-2 flex items-center   px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
    toggleClass:
      "py-3  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  },
  {
    title: "women",
    path: "/shop",
    class:
      "py-2 flex items-center   px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
    toggleClass:
      "py-3  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  },
  {
    title: "Blog",
    path: "/blog",
    class:
      "py-2  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
    toggleClass:
      "py-3  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  },
  {
    title: "FAQs",
    path: "/faqs",
    class:
      "py-2  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
    toggleClass:
      "py-3  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  },
  // {
  //   title: "Dashboard",
  //   path: "/user/dashboard",
  //   class:
  //     "py-2  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  //   toggleClass:
  //     "py-3  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  // },
  // {
  //   title: "SA Dashboard",
  //   path: "/super-admin/dashboard/overview",
  //   class:
  //     "py-2  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  //   toggleClass:
  //     "py-3  px-3 font-medium hover:bg-red-700 duration-500 hover:text-white rounded-lg",
  // },
  {
    title: "Track your order",
    path: "/trackOrder",
    class:
      "py-2 px-4 font-medium hover:bg-red-600 bg-gray-900 duration-300 text-white rounded-lg",
    toggleClass:
      "py-3 px-3 font-medium bg-blue-900 text-white duration-300 text-white rounded-lg",
  },
];

export const Icon = [
  { path: "/facebook", icon: "facebook" },
  { path: "/instagram", icon: "instagram" },
  { path: "/twitter", icon: "twitter" },
  { path: "/linkedin", icon: "linkedin" },
];
